import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const SpeedDatingWrapper = styled.div`
  .content {
    margin: 0 auto;
    width: 90%;
    max-width: 100rem;

    @media (max-width: ${TABLET_WIDTH}px) {
      .carousel {
        height: calc(100vh - 43vh) !important;
      }
      .carousel .carousel-item {
        height: calc(100vh - 50vh) !important;
      }
    }
  }

  .title {
    font-size: 1.6rem;
    text-align: left;
    color: ${black};
    font-family: ${RalewayFont.regularFamily};
    line-height: 2.1rem;
    padding-bottom: 0.2rem;
    margin: 2rem 0rem 1rem;
    display: inline-block;
  }

  .no_elements {
    div {
      color: ${black};
    }
  }

  .matches {
    margin-top: 2rem;
    > div {
      margin-bottom: 1rem;
    }

    @media (max-width: ${TABLET_WIDTH}px) {
      margin-top: 7rem;
      margin-bottom: 10rem;
    }
  }
`;

export const LoadingWrapper = styled.div`
  width: clamp(20vw, 40rem, 100vw);
  height: clamp(20vw, 40rem, 100vw);
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
`;

export const Header = styled.div`
  @media (min-width: 1710px) {
    margin-bottom: -14rem;
  }


  text-align: left;
  padding: 2rem 2rem 0;
  .icon {

    display: inline-block;
    vertical-align: middle;
    margin-right: 1rem;

    .back {
      cursor: pointer;
    }

    img {
      padding: 0 1rem;
      height: 2.4rem;
      display: inline-block;
      width: 5rem;
    }
  }

  .description {
    display: inline-block;
    vertical-align: middle;
    font-size: 1.4rem;
    color: ${black};
    width: calc(100% - 15rem);
    font-family: ${RalewayFont.semiBoldFamily};

    strong {
      font-family: ${RalewayFont.boldFamily};
    }
  }

  .card_info {
    width: 18rem;
    margin-right: 1rem;
    border-radius: 1.5rem;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border: 0.1rem solid #e9e9e9;
    margin-top: 2rem;
    .header {
      border-radius: 1.5rem 1.5rem 0 0;
      background-color: #8AD923;
      padding: 1rem;
      color: #fff;

      .icon {

        background: white;
        border-radius: 100%;
        border-radius: 100%;
        width: 3rem;
        height: 3rem;
        margin-right: 1rem;
        display: inline-block;
        vertical-align: middle;
        img {
            height: 3rem;
            width: 3rem;
        }
      }

      .data {
        margin-right: 1rem;
        font-size: 1.8rem;
        width: calc(100% - 5rem);
        font-family: ${RalewayFont.semiBoldFamily};
        color: white;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
      }

      .type {
        text-align: center;
        color: white;
        font-size: 15px;
        font-weight: 600;
      }
    }

    .body {
      color: ${black};
      padding: 1rem;

      img {
        display: inline-block;
        max-width: 1.4rem;
        vertical-align: middle;
        margin-right: 1rem;
      }

      .data {
        display: inline-block;
        width: calc(100% - 2.5rem);
        vertical-align: middle;
        font-size: 1.3rem;
      }
    }
  }
`;

export const NoElements = styled.div`
  width: calc(100% - 4rem);
  height: 30rem;
  padding: 2rem;
  margin: 2rem auto;
  background: #F3F3F3;
  border-radius: 3rem;
  display: flex;
  align-items: center;

  @media (min-width: 1710px) {
    margin-top: 5rem;
  }

  .nocontent {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      width: 20rem;
    }

    .text {
      margin-top: 1rem;
      font-size: 1.6rem;
      text-align: center;
      color: black;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/routes/SpeedDating/components/styles.js